import React from 'react'
import { Link } from 'react-router-dom'
import { Panel } from 'rsuite'

import './StatCard.scss'

export interface StatCardProps {
  title: string
  count: number
  icon: React.ReactNode
  color: string
  link?: string
  onClick?: () => void
  className?: string
}

export default function StatCard ({
  title,
  count,
  icon,
  color,
  link,
  onClick,
  className = ''
}: StatCardProps) {
  const cardContent = (
    <>
      <div className="StatCard__Icon" style={{ backgroundColor: color }}>
        {icon}
      </div>
      <div className="StatCard__Content">
        <div className="StatCard__Count">{count}</div>
        <div className="StatCard__Title">{title}</div>
      </div>
    </>
  )

  const panelProps = {
    className: `StatCard ${className}`.trim(),
    shaded: true,
    bordered: true,
    onClick: onClick
  }

  if (link) {
    return (
      <Panel {...panelProps} as={Link} to={link}>
        {cardContent}
      </Panel>
    )
  }

  return (
    <Panel {...panelProps}>
      {cardContent}
    </Panel>
  )
}
